export const FETCH_ROSTER_PERIOD = "FETCH_ROSTER_PERIOD";
export const CREATE_ROSTER_PERIOD = "CREATE_ROSTER_PERIOD";
export const DELETE_ROSTER_PERIOD = "DELETE_ROSTER_PERIOD";
export const FETCH_ROSTER_DDL = "FETCH_ROSTER_DDL";
